// Importing a text file into a draft: the site's editor and the desktop overlay take the same files.

/** What the file picker offers. */
export const TEXT_FILE_ACCEPT = '.txt,.md,.markdown,text/plain,text/markdown';

const MAX_TEXT_FILE_BYTES = 256 * 1024;

/** Why `file` can't be imported, before reading it, or null when it can be. */
export function textFileProblem(file: File): 'wrongFileType' | 'fileTooLarge' | null {
  if (!/\.(txt|md|markdown)$/i.test(file.name)) return 'wrongFileType';
  if (file.size > MAX_TEXT_FILE_BYTES) return 'fileTooLarge';
  return null;
}

/** The file's text, without a byte order mark; null when it has none that's readable. */
export async function readTextFile(file: File): Promise<string | null> {
  const text = (await file.text()).replace(/^\uFEFF/, '');
  return !text || text.includes('\0') ? null : text;
}
